import styled from 'styled-components';

const StyledPriceCols = styled.div`
padding: 0 64px ${props => props.theme.components_spacing_desk.xlarge}px;
.tabs-title {
  padding-bottom: ${props => props.theme.components_spacing_desk.large}px;
  text-align: center;
}
.tabs-wrap {
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.home--col{
  position: relative;
  width: 22%;
  margin-right: 3%;
  display: flex;
  flex-direction: column;
  p {
    padding-left: 10px;
  }
}
.text-01 {
  flex: 0 0 70px;
}
.grey{
  color: #666666;
}
.col-separator{
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #B3B3B3;
  margin: 24px 0;
}
small {
  font-size: 14px
}
.col-separator::before{
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.green_secondary};
  
}
.charts-wrap {
  position: relative;
  width: 100%;
  padding: 0 0 100px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  &.custom--header {
    background: ${props => props.theme.colors.green_secondary};
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    min-height: 150px;
  }
  .circle {
    position: relative;
    width: 20%;
    border-radius: 50%;
    border: 2px solid ${props => props.theme.colors.green_secondary};
    max-width: 50px;
    &:after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }
    .inner {
      position: absolute;
      width: 80%;
      height: 80%;
      left: 10%;
      top: 10%;
      display: block;
      border-radius: 50%;
      &.selected {
        background-color: ${props => props.theme.colors.green_secondary};
      }
    }
  }
}
.title-pack {
  padding: 10px;
  &.title-pack-custom {
    background: ${props => props.theme.colors.green_secondary};
    color: #fff;
  }
}
@media screen and (max-width: 1439px){
  padding: ${props => props.theme.components_spacing_desk.medium}px 40px ${props => props.theme.components_spacing_desk.xlarge}px;
}
@media screen and (max-width: 1023px){
  padding: 0 40px ${props => props.theme.components_spacing_tablet.xlarge}px;
  .tabs-title {
    padding-bottom: ${props => props.theme.components_spacing_tablet.large}px 
  }
  .tabs-wrap {
    flex-wrap: wrap;
  }
  .home--col{
    width: 49%;
    margin: 0 auto 80px;
  }
}
@media screen and (max-width: 767px){
  padding: 0 24px ${props => props.theme.components_spacing_mobile.xlarge}px;
  flex-direction: column;
  .tabs-title {
    padding-bottom: ${props => props.theme.components_spacing_mobile.large}px;
  }
  .home--col{
    width: 100%;
    margin: 0 auto 80px;
  }
  .text-01 {
    flex: 0 0 auto;
  }
  .charts-wrap {
    padding: 0 0 40px;
    .circle { 
      width: 50px;
    }
  }
  
}
`;

export {
  StyledPriceCols
}